export const SET_PROPERTY_DREAM = "SET_PROPERTY_DREAM";
export const DREAMS_RECEIVED = "DREAMS_RECEIVED";
export const REMOVE_DREAM = "REMOVE_DREAM";
export const APPEND_DREAM = "APPEND_DREAM";
export const CREATE_DREAM = "CREATE_DREAM";
export const SET_DREAM = "SET_DREAM";
export const SET_DREAM_IMAGE = "SET_DREAM_IMAGE";
